/** V1 gate retag + processing machine label and issue strings (English), spread into en.ts. Hindi: v1-gate-process.hi.ts. */
export const v1GateProcessEn = {
  // Gate — new tag on a bag or sample kept without one (supervisor)
  'gate.v1.retag.tile': 'New tag',
  'gate.v1.retag.tileLine': '{count} waiting',
  'gate.v1.retag.waitNotice':
    '{count} {count:bag or sample waits|bags or samples wait} for a new tag — call the supervisor',
  'gate.v1.retag.title': 'New tag',
  'gate.v1.retag.count': '{count} {count:bag or sample|bags or samples} kept without a tag',
  'gate.v1.retag.none': 'Nothing waits for a tag',
  'gate.v1.retag.noneHint':
    'Bags and samples the office kept without a tag show here after sending.',
  'gate.v1.retag.supOnly': 'Only the supervisor puts a new tag. His PIN will be asked.',
  'gate.v1.retag.bag': 'Bag · lot {lot}',
  'gate.v1.retag.sample': 'Sample · lot {lot}',
  'gate.v1.retag.conflict': 'Old code {code} was on another bag',
  'gate.v1.retag.pick': 'Pick a bag',
  'gate.v1.retag.home': 'Home',
  'gate.v1.retag.scanTag': 'Scan the new tag',
  'gate.v1.retag.scanSeal': 'Scan the new seal',
  'gate.v1.retag.holdTag': 'Hold the new tag in the box',
  'gate.v1.retag.holdSeal': 'Hold the new seal in the box',
  'gate.v1.retag.tagScanned': 'Tag {code} scanned',
  'gate.v1.retag.sealScanned': 'Seal {code} scanned',
  'gate.v1.retag.again': 'Scan again',
  'gate.v1.retag.saveTag': 'Save the new tag',
  'gate.v1.retag.saveSeal': 'Save the new seal',
  'gate.v1.retag.supReason': 'New tag on a bag or sample kept without one.',
  'gate.v1.retag.saved': 'New tag {code} saved',
  'gate.v1.retag.doneTitle': 'New tag saved',
  'gate.v1.retag.doneLine': 'Tag {code} · nothing else waits',

  // Processing — machine label
  'process.v1.machineLabel.tile': 'Machine label',
  'process.v1.machineLabel.tileLine': '{count} {count:machine|machines} without a label',
  'process.v1.machineLabel.title': 'Which machine?',
  'process.v1.machineLabel.pickHint': 'Machines without a label',
  'process.v1.machineLabel.pickWait': 'Pick the machine',
  'process.v1.machineLabel.allLabelled': 'Every machine has a label',
  'process.v1.machineLabel.site': 'Site {site}',
  'process.v1.machineLabel.scanTitle': 'Scan the label',
  'process.v1.machineLabel.scanHint': 'Stick the label, hold it in the box',
  'process.v1.machineLabel.typeTitle': 'Type the label number',
  'process.v1.machineLabel.photoTitle': 'Photo of the label',
  'process.v1.machineLabel.machine': 'Machine',
  'process.v1.machineLabel.label': 'Label',
  'process.v1.machineLabel.siteLabel': 'Site',
  'process.v1.machineLabel.photo': 'Label on the machine',
  'process.v1.machineLabel.photoHint': 'Machine and label in one photo',
  'process.v1.machineLabel.photoTaken': 'Photo taken',
  'process.v1.machineLabel.photoFailed': 'Photo not saved. Try again.',
  'process.v1.machineLabel.takePhoto': 'Take the photo',
  'process.v1.machineLabel.save': 'Save the label',
  'process.v1.machineLabel.doneTitle': 'Label saved',
  'process.v1.machineLabel.doneLine': 'Machine {machine} · label {code}',

  // Processing — issue bags to a run (store keeper)
  'process.v1.issue.tile': 'Bags to the run',
  'process.v1.issue.tileLine': '{count} {count:task|tasks}',
  'process.v1.issue.title': 'Bags to the run',
  'process.v1.issue.pick': 'Pick a task',
  'process.v1.issue.home': 'Home',
  'process.v1.issue.none': 'No bags to give',
  'process.v1.issue.noneBody':
    'The office sets each task. Download the site list again to see new ones.',
  'process.v1.issue.lots': 'Lot {lots}',
  'process.v1.issue.toRun': 'To run …{run} · {step}',
  'process.v1.issue.progress': '{n} of {m} bags given',
  'process.v1.issue.lotsLabel': 'Lot',
  'process.v1.issue.runLabel': 'Run',
  'process.v1.issue.bagsLabel': 'Bags',
  'process.v1.issue.count': '{n} / {m}',
  'process.v1.issue.kgSoFar': 'Kilos so far',
  'process.v1.issue.scan': 'Bag on the scale: scan its tag',
  'process.v1.issue.allIn': 'All bags given',
  'process.v1.issue.carryHint': 'Keep each bag near the machine with the run’s other bags.',
  'process.v1.issue.saved': 'Tag {no}: {kg} kg given',
  'process.v1.issue.scanFirst': 'Scan a bag first',
  'process.v1.issue.moistureMissing': 'Write each lot’s moisture once first',
  'process.v1.issue.done': 'Giving done',
  'process.v1.issue.otherTask': 'Other tasks',
  'process.v1.issue.shortTitle': 'Some bags not given',
  'process.v1.issue.shortConfirm': '{n} {n:bag was|bags were} not given. Finish anyway?',
  'process.v1.issue.weighTitle': 'Weigh the bag',
  'process.v1.issue.weightHint': 'Only this bag on the scale · lot {lot}',
  'process.v1.issue.weight': 'Scale reading',
  'process.v1.issue.weightWait': 'Type the weight',
  'process.v1.issue.save': 'Save the bag',
  'process.v1.issue.moistureTitle': 'Moisture',
  'process.v1.issue.moisture': 'Moisture of this lot',
  'process.v1.issue.moistureNeeded': 'Needed once for each lot (for drying)',
  'process.v1.issue.moistureOnce': 'Once for each lot, if there is a meter',
  'process.v1.issue.moistureWait': 'Type the moisture',
  'process.v1.issue.bagTag': 'Bag',
  'process.v1.issue.netShort': 'Grain',
  'process.v1.issue.doneTitle': 'Giving done',
  'process.v1.issue.doneLine': 'Bags given to run …{run}',
}

export type V1GateProcessMessageKey = keyof typeof v1GateProcessEn
